import { createSelector } from "reselect";
import { RootState } from "./reducers/root-reducers";
import { GlobalStateProps } from "./reducers/global-state-reducer";
import { AlertStateProps } from "./reducers/alerts-reducer";
import { ApiRequestState } from "../types/state-management";

const globalState = (state: RootState) => state.globalState;
const alertState = (state: RootState) => state.alert;
const authState = (state: RootState) => state.auth;
const userState = (state: RootState) => state.user;
const roleState = (state: RootState) => state.role;
const departmentState = (state: RootState) => state.department;
const groupingState = (state: RootState) => state.grouping;
const articleState = (state: RootState) => state.article;
const newsState = (stata: RootState) => stata.news;
const projectState = (state: RootState) => state.project;
const sliderState = (state: RootState) => state.slider;
const infoState = (state: RootState) => state.info;
const faqState = (state: RootState) => state.faq;
const usefulLinksState = (state: RootState) => state.usefulLinks;
const usefulLinkGroupsState = (state: RootState) => state.usefulLinkGroups;
const detailState = (state: RootState) => state.detail;
const newTokenState = (state: RootState) => state.newToken;
const resetPasswordState = (state: RootState) => state.resetPassword;
const cooperationState = (state: RootState) => state.cooperation;
const notificationState = (state: RootState) => state.notification;
const cooperationReqState = (state: RootState) => state.cooperationReq;
const catalogState = (state: RootState) => state.catalog;
const cooperationAppricants = (state: RootState) =>
  state.cooperationsAppricants;

export const selectGlobalState = createSelector(
  [globalState],
  (globalState: GlobalStateProps) => ({
    isLogined: globalState.isLogined,
    rememberMe: globalState.rememberMe,
    theme: globalState.theme,
    persistUsername: globalState.persistUsername,
    persistPassword: globalState.persistPassword,
    currentUserData: globalState.currentUserData,
    urlOfPages: globalState.urlOfPages,
    departmentsData: globalState.departmentsData,
    usersData: globalState.usersData,
    rolesData: globalState.rolesData,
    rowStatus: globalState.rowStatus,
    groupingData: globalState.groupingData,
    articlesData: globalState.articlesData,
    newsData: globalState.newsData,
    projectsData: globalState.projectsData,
    faqData: globalState.faqData,
    newTokenNeeded: globalState.newTokenNeeded,
    catalog: globalState.catalog,
  })
);

export const selectAlertState = createSelector(
  [alertState],
  (alertState: AlertStateProps) => ({
    alert: alertState.alert,
    alertSeverity: alertState.alertSeverity,
    alertContext: alertState.alertContext,
  })
);

export const selectAuthState = createSelector(
  [authState],
  (authState: ApiRequestState) => ({
    loading: authState.loading,
    data: authState.data,
    error: authState.error,
  })
);

export const selectUserState = createSelector(
  [userState],
  (userState: ApiRequestState) => ({
    loading: userState.loading,
    data: userState.data,
    error: userState.error,
  })
);

export const selectRoleState = createSelector(
  [roleState],
  (roleState: ApiRequestState) => ({
    loading: roleState.loading,
    data: roleState.data,
    error: roleState.error,
  })
);

export const selectDepartmentState = createSelector(
  [departmentState],
  (departmentState: ApiRequestState) => ({
    loading: departmentState.loading,
    data: departmentState.data,
    error: departmentState.error,
  })
);

export const selectGroupingState = createSelector(
  [groupingState],
  (groupingState: ApiRequestState) => ({
    loading: groupingState.loading,
    data: groupingState.data,
    error: groupingState.error,
  })
);

export const selectArticleState = createSelector(
  [articleState],
  (articleState: ApiRequestState) => ({
    loading: articleState.loading,
    data: articleState.data,
    error: articleState.error,
  })
);

export const selectNewsState = createSelector(
  [newsState],
  (newsState: ApiRequestState) => ({
    loading: newsState.loading,
    data: newsState.data,
    error: newsState.error,
  })
);

export const selectProjectState = createSelector(
  [projectState],
  (projectState: ApiRequestState) => ({
    loading: projectState.loading,
    data: projectState.data,
    error: projectState.error,
  })
);

export const selectSliderState = createSelector(
  [sliderState],
  (sliderState: ApiRequestState) => ({
    loading: sliderState.loading,
    data: sliderState.data,
    error: sliderState.error,
  })
);

export const selectInfoState = createSelector(
  [infoState],
  (infoState: ApiRequestState) => ({
    loading: infoState.loading,
    data: infoState.data,
    error: infoState.error,
  })
);

export const selectFaqState = createSelector(
  [faqState],
  (faqState: ApiRequestState) => ({
    loading: faqState.loading,
    data: faqState.data,
    error: faqState.error,
  })
);

export const selectUsefulLinksState = createSelector(
  [usefulLinksState],
  (usefulLinksState: ApiRequestState) => ({
    loading: usefulLinksState.loading,
    data: usefulLinksState.data,
    error: usefulLinksState.error,
  })
);

export const selectUsefulLinkGroupsState = createSelector(
  [usefulLinkGroupsState],
  (usefulLinkGroupsState: ApiRequestState) => ({
    loading: usefulLinkGroupsState.loading,
    data: usefulLinkGroupsState.data,
    error: usefulLinkGroupsState.error,
  })
);
export const selectDetailState = createSelector(
  [detailState],
  (detailState: ApiRequestState) => ({
    loading: detailState.loading,
    data: detailState.data,
    error: detailState.error,
  })
);

export const selectNewTokenState = createSelector(
  [newTokenState],
  (newTokenState: ApiRequestState) => ({
    loading: newTokenState.loading,
    data: newTokenState.data,
    error: newTokenState.error,
  })
);

export const selectResetPasswordState = createSelector(
  [resetPasswordState],
  (resetPasswordState: ApiRequestState) => ({
    loading: resetPasswordState.loading,
    data: resetPasswordState.data,
    error: resetPasswordState.error,
  })
);

export const selectCooperationStateState = createSelector(
  [cooperationState],
  (cooperationState: ApiRequestState) => ({
    loading: cooperationState.loading,
    data: cooperationState.data,
    error: cooperationState.error,
  })
);

export const selectNotificationStateState = createSelector(
  [notificationState],
  (notificationState: ApiRequestState) => ({
    loading: notificationState.loading,
    data: notificationState.data,
    error: notificationState.error,
  })
);

export const selectCooperationReqState = createSelector(
  [cooperationReqState],
  (cooperationReqState: ApiRequestState) => ({
    loading: cooperationReqState.loading,
    data: cooperationReqState.data,
    error: cooperationReqState.error,
  })
);

export const selectCooperationAppricantsState = createSelector(
  [cooperationAppricants],
  (cooperationAppricants: ApiRequestState) => ({
    loading: cooperationAppricants.loading,
    data: cooperationAppricants.data,
    error: cooperationAppricants.error,
  })
);

export const selectCatalogState = createSelector(
  [catalogState],
  (catalogState: ApiRequestState) => ({
    loading: catalogState.loading,
    data: catalogState.data,
    error: catalogState.error,
  })
);
